<template>
  <v-card class="demo-user-notification">
    🚀
    <span>
      {{ $t('demo_user_message') }}
    </span>
  </v-card>
</template>

<script>
export default {
  name: 'DemoUserRoleNotification',
};
</script>

<style lang="scss">
.demo-user-notification {
  position: fixed;
  top: 15px;
  left: 50%;
  transform: translate(-50%);
  z-index: 1000;
  padding: 9px 12px;
  color: orange !important;
  font-weight: 500;
  font-size: 14px;
}
</style>
